import Accordion from "../UI/Accordion";
import VerticalGanttChartTransportationIcon from "../ganttChart/verticalGanttChart/VerticalGanttChartTransportationIcon";
import TimePicker from "../UI/input/TimePicker";
import { ReactComponent as CloseIcon } from "../../assets/icons/x_black.svg";
import { EmployeeTransport, TransportationType } from "../../types/ganttChart";
import labels from "../../utils/labels";
import { useAppSelector } from "../../store/hooks";
import EmployeeSettingsStyles from "../../styles/employeeSettings.module.css";

type TransportOption = {
  id: TransportationType;
  title: string;
};

const EmployeeTransportListItem = ({
  transport,
  options,
  onTypeChange,
  onStartChange,
  onEndChange,
  canDelete,
  onDelete,
  disableAll,
  disableTimeWindow,
}: {
  transport: EmployeeTransport;
  options: TransportOption[];
  onTypeChange: (newType: TransportationType) => void;
  onStartChange: (newStart: string) => void;
  onEndChange: (newEnd: string) => void;
  canDelete: boolean;
  onDelete: () => void;
  disableAll?: boolean;
  disableTimeWindow?: boolean;
}) => {
  const { manualEdits } = useAppSelector(
    (state) => state.employeeSettingsSlice,
  );
  const { employeeShiftId, manualShiftChanges } = useAppSelector(
    (state) => state.drawerSlice.selectedEmployee!,
  );

  const isTimeWindowDisabled = disableAll || disableTimeWindow;

  const manualTransportTypeEdits =
    manualEdits[employeeShiftId]?.transportationType ??
    manualShiftChanges?.transportationType;

  const displayOptionIndex = options.findIndex(
    (option) => option.id === transport.type,
  );

  const transportIcon = (option: TransportOption, isSelected: boolean) => {
    const iconColor = disableAll
      ? "var(--col-text-secondary)"
      : isSelected
        ? "var(--col-interaction-secondary)"
        : "var(--col-text-secondary)";

    return (
      <VerticalGanttChartTransportationIcon
        type={option.id}
        color={iconColor}
        size={16}
      />
    );
  };

  return (
    <div
      className={`flex gap-[var(--spacing-md)] items-start
        ${manualTransportTypeEdits && EmployeeSettingsStyles.editedSetting}`}
    >
      <Accordion
        onChange={(newOption: TransportOption) => onTypeChange(newOption.id)}
        options={options}
        variant="PRIMARY"
        defaultText={labels.chooseTransport}
        label={labels.transportType}
        classes="w-full"
        displayOption={displayOptionIndex}
        leadingElement={transportIcon}
        labelKey="title"
        disabled={disableAll}
        helperText={manualTransportTypeEdits && labels.manuallyEditedTransport}
      />
      <div className="flex gap-[var(--spacing-sm)] w-full">
        <TimePicker
          id="transport-start-time"
          value={transport.timeWindow.transportStartTime}
          onTimeChange={(newStart) => onStartChange(newStart)}
          label={labels.startTimeTransport}
          classes="w-full"
          disabled={isTimeWindowDisabled}
        />
        <TimePicker
          id="transport-end-time"
          value={transport.timeWindow.transportEndTime}
          onTimeChange={(newEnd) => onEndChange(newEnd)}
          label={labels.endTimeTransport}
          classes="w-full"
          disabled={isTimeWindowDisabled}
        />
      </div>
      {canDelete && (
        <div className="h-[40px] flex items-center">
          <CloseIcon
            width={20}
            height={20}
            onClick={onDelete}
            className="cursor-pointer"
          />
        </div>
      )}
    </div>
  );
};

export default EmployeeTransportListItem;
